import { Map } from 'immutable'
import {
  SET_SCREENS_DATA,
  SET_SCREENS_PROCESSING,
  SET_SCREENS_ERROR,
  SET_SCREEN_DATA,
} from './actions'

export const initialState = Map()

export default (state = initialState, action) => {
  const { payload, type } = action
  switch (type) {
    case SET_SCREENS_PROCESSING:
      return state.setIn(['processing'], payload.processing)
    case SET_SCREEN_DATA: {
      const screenId = payload.data.get('id')
      return state
        .setIn(['screens', screenId], payload.data)
        .setIn(['processing'], false)
    }
    case SET_SCREENS_DATA:
      return state
        .set('screens', payload.data)
        .setIn(['processing'], false)
    case SET_SCREENS_ERROR:
      return state
        .setIn(['error'], payload.error)
        .setIn(['processing'], false)
    default:
      return state
  }
}
